import { render, staticRenderFns } from "./inspectionsModal.vue?vue&type=template&id=1152afd4&scoped=true&"
import script from "./inspectionsModal.vue?vue&type=script&lang=js&"
export * from "./inspectionsModal.vue?vue&type=script&lang=js&"
import style0 from "./inspectionsModal.vue?vue&type=style&index=0&id=1152afd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152afd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1152afd4')) {
      api.createRecord('1152afd4', component.options)
    } else {
      api.reload('1152afd4', component.options)
    }
    module.hot.accept("./inspectionsModal.vue?vue&type=template&id=1152afd4&scoped=true&", function () {
      api.rerender('1152afd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/inspections/inspectionsModal.vue"
export default component.exports